// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3XcdM","calendarButtons":"ClockData_calendarButtons__VKd8a"};